import { getMessageSearchData, MessageSearchDefault, SearchMessage } from "../model/Message";
import { Result } from "../model/Result";
import axiosCilent from "./axiosClient";

// お知らせ件数取得APIリクエスト
export const requestRdbAdminMessagesCount = async (
    tenantId: string,
    uid: string | undefined,
    SearchData: SearchMessage = MessageSearchDefault()
): Promise<number> => {
  try{
    const messageSearchData = getMessageSearchData(SearchData, '', '');
    const postData = {
      tenantId,
      uid,
      ...messageSearchData
    }
    const response = await axiosCilent.post(`getRdbAdminMessagesCount`, postData);
    return response.data.count;
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// お知らせ一覧取得APIリクエスト
export const requestRdbAdminMessages = async (
    tenantId: string,
    uid: string,
    pageCount: string,
    selectPage: string,
    SearchData: SearchMessage = MessageSearchDefault()
): Promise<Result> => {
  try{
    const messageSearchData = getMessageSearchData(SearchData, '', '');
    const postData = {
      tenantId,
      uid,
      pageCount,
      selectPage,
      ...messageSearchData
    }
    const response = await axiosCilent.post(`getRdbAdminMessages`, postData);
    return {
      success: true,
      data: response.data.data.rows
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};